import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class grittiVeloceIMPRESAgas {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 209,
        Id_Foritore: 2,
        Id_comodity: 2,
        TipoContratto:2,
        NomeOfferta: "VELOCE IMPRESA gas",
        LinkFoto: "./assets/images/offerte-gritti/Veloce-IMPRESA-gas.jpg",
        LinkFotoLarge: "./assets/images/offerte-gritti/Veloce-IMPRESA-gas.jpg",
        LinkFotoMid: "./assets/images/offerte-gritti/Veloce-IMPRESA-gas.jpg",
        LinkFotoSm: "./assets/images/offerte-gritti/Veloce-IMPRESA-gas.jpg",
        LinkFotoCarousel: "./assets/images/offerte-gritti/Veloce-IMPRESA-gas.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "PREZZO COMPONENTE ENERGETICA BLOCCATO PER 12 MESI - Offerta di MERCATO LIBERO riservata alle utenze NON DOMESTICHE con consumi fino a",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "VANTAGGI ASSICURATI",
            DescrizioneSezione: "",
            lstPunti: ["0 COSTI DI ATTIVAZIONE","12 MESI PREZZO FISSO","0 DEPOSITO CAUZIONALE","AREA RISERVATA WEB","ASSISTENZA CLIENTI",
            ]
          },
      
        ],
        PrezzoEle: 0,
        PrezzoGas: 0.3158,
       
        TitoloPlus: "VANTAGGI ASSICURATI",
        Plus:["0 COSTI DI ATTIVAZIONE","12 MESI PREZZO FISSO","0 DEPOSITO CAUZIONALE","AREA RISERVATA WEB","ASSISTENZA CLIENTI",
      ]
      ,schedaconfrontabilitaele:  
      { tabellaConfrontabilita:[ ]}

      ,schedaconfrontabilitagas:  { tabellaConfrontabilita:[ { zona:1, consumoannuo:120,importo:0},{ zona:1, consumoannuo:480,importo:0},{ zona:1, consumoannuo:70,importo:0},{ zona:1, consumoannuo:1400,importo:0},{ zona:1, consumoannuo:2000,importo:0},{ zona:1, consumoannuo:5000,importo:0} ,{ zona:2, consumoannuo:120,importo:0},{ zona:2, consumoannuo:480,importo:0},{ zona:2, consumoannuo:70,importo:0},{ zona:2, consumoannuo:1400,importo:0},{ zona:2, consumoannuo:2000,importo:0},{ zona:2, consumoannuo:5000,importo:0} ,{ zona:3, consumoannuo:120,importo:0},{ zona:3, consumoannuo:480,importo:0},{ zona:3, consumoannuo:70,importo:0},{ zona:3, consumoannuo:1400,importo:0},{ zona:3, consumoannuo:2000,importo:0},{ zona:3, consumoannuo:5000,importo:0} ,{ zona:4, consumoannuo:120,importo:0},{ zona:4, consumoannuo:480,importo:0},{ zona:4, consumoannuo:70,importo:0},{ zona:4, consumoannuo:1400,importo:0},{ zona:4, consumoannuo:2000,importo:0},{ zona:4, consumoannuo:5000,importo:0} ,{ zona:5, consumoannuo:120,importo:0},{ zona:5, consumoannuo:480,importo:0},{ zona:5, consumoannuo:70,importo:0},{ zona:5, consumoannuo:1400,importo:0},{ zona:5, consumoannuo:2000,importo:0},{ zona:5, consumoannuo:5000,importo:0} ,{ zona:6, consumoannuo:120,importo:0},{ zona:6, consumoannuo:480,importo:0},{ zona:6, consumoannuo:70,importo:0},{ zona:6, consumoannuo:1400,importo:0},{ zona:6, consumoannuo:2000,importo:0},{ zona:5, consumoannuo:5000,importo:0}]}
      ,lstModalitaPagamento :["1","2"]
      ,scontoRid:0 
      ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
      ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };;
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/grittiVeloceIMPRESAgas.ts